/* eslint-disable global-require */

import angular from 'angular';

import DeliveryFormController from './delivery-form.controller';

export default angular.module('autoboard.formDelivery', [])
  .directive('formDelivery', () => {
    'ngInject';

    return {
      controller: DeliveryFormController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '=',
      },
      templateUrl: require('./delivery-form.template.html'),
    };
  })
  .name;
